<template>
  <footer class="footer py-3">
    <div class="row text-center">
      <div class="col-sm-4">{{ new Date().getFullYear() }} © Namirembe Diocese Young Sacco.</div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
  },
};
</script>